import { getFragmentData } from '@e-socna/data-layer';
import { normalizeOrganizationIdentifierValue } from '@e-socna/third-parties';

import { ThirdPartiesCmp_Organization_Fragment } from '../../../components/ThirdParties/fragments/organization.fragment';
import type { ThirdPartiesCmp_SomeOrganization } from '../../../components/ThirdParties/queries/some-organizations.query';

export const buildExistingOrganizationIdentifiers = (
  organizations: readonly ThirdPartiesCmp_SomeOrganization[],
): ReadonlySet<string> =>
  new Set(
    getFragmentData(ThirdPartiesCmp_Organization_Fragment, organizations)
      .map((organization) => organization.identifier?.value)
      .filter((value): value is string => !!value)
      .map(normalizeOrganizationIdentifierValue),
  );
